import { Image } from "antd";
import { NotFoundIcon } from "config/IconConfig";
import * as S from "./NotFound.styles";

export const NotFound = () => {
  return (
    <S.NotFoundWrapper>
      <S.ImgWrapper>
        <Image src={NotFoundIcon} alt="Not found" preview={false} />
      </S.ImgWrapper>
      <S.Text>Not Found</S.Text>
    </S.NotFoundWrapper>
  );
};
